import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='cardNetwork' subtitle='PrimerCardNetwork' mdxType="Item">
Represents a card network with metadata including display name, network type, and whether it is allowed.
  <Group mdxType="Group">
    <Item title='network' subtitle='CardNetwork.Type' mdxType="Item">
    The type of card network (e.g., VISA, MASTERCARD).
    </Item>
    <Item title='displayName' subtitle='String' mdxType="Item">
      The human-readable name of the card network (e.g., Visa, Mastercard).
    </Item>
    <Item title='allowed' subtitle='Boolean' label='Required' mdxType="Item">
      A boolean indicating whether this card network is allowed.
    </Item>
  </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      